<script lang="ts">
    import PayrollComplianceReportListing from '../../components/admin/report/payrollComplianceReport/payrollComplianceReportListing.svelte';
  </script>
  
  <div class="payroll-compliance-report-listing-page">
    <PayrollComplianceReportListing />
  </div>
  
  <style>
    .payroll-compliance-report-listing-page {
      min-height: 100vh;
      background-color: #f9fafb;
    }
  </style>      